module.exports = __webpack_public_path__ + "img/penguin.73f2f4d3.svg";